import * as React from 'react';

import { bemBlock } from '../../modules/bem';
import { Icon } from '../icon/Icon';

import './InputSelectButton.less';

const block = bemBlock('input-select-button');

type ButtonProps = {
  placeholder?: string;
  variant?: 'small' | 'medium' | 'large';
};

export const Button = React.forwardRef<
  React.ElementRef<'button'>,
  React.ComponentPropsWithoutRef<'button'> & ButtonProps
>(function Button({ className, children, placeholder, variant, ...props }, ref) {
  const content = children ?? placeholder;

  return (
    <button
      ref={ref}
      className={block({ extra: className, modifiers: { variant } })}
      {...props}
      data-placeholder={children ? undefined : 'true'}
    >
      {content && <div className={block('content')}>{content}</div>}
      <Icon glyph="chevron-down" className={block('icon')} />
    </button>
  );
});
